import { render, staticRenderFns } from "./rebind.vue?vue&type=template&id=507c1cf8"
import script from "./rebind.vue?vue&type=script&lang=js"
export * from "./rebind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports